export default "__VITE_ASSET__BstPPCCa__"